var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4674 8.50305V8.50611C6.46443 8.50611 5.52963 8.50305 5.28036 9.42301C5.05185 10.2666 4.40788 12.5945 4.39007 12.6586H4.21202C4.21202 12.6586 3.55321 10.2788 3.32174 9.41995C3.07246 8.5 2.1347 8.50305 2.1347 8.50305H0V15.5H2.13569V11.3444H2.31374L3.56014 15.5H5.04295L6.28934 11.3474H6.4674V15.5H8.60308V8.50305H6.4674ZM14.2692 8.50305C14.2692 8.50305 13.6431 8.56112 13.3493 9.2366L11.8368 12.6586H11.6587V8.50305H9.52304V15.5H11.54C11.54 15.5 12.1959 15.4389 12.4897 14.7665L13.9725 11.3444H14.1506V15.5H16.2862V8.50305H14.2692ZM17.2358 11.6806V15.5H19.3715V13.2699H21.6853C22.6943 13.2699 23.548 12.6067 23.8655 11.6816H17.2358V11.6806Z",
    fill: "#4DB45E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6862 8.5H16.936C17.1734 9.83256 18.1438 10.9013 19.3981 11.2497C19.6893 11.3309 19.9897 11.372 20.2914 11.372H23.9524C23.9851 11.213 23.9999 11.051 23.9999 10.8829C23.9999 9.56666 22.9642 8.5 21.6862 8.5Z",
    fill: "url(#paint0_linear_170_2303)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_2303",
    x1: 16.936,
    y1: 10.436,
    x2: 23.9999,
    y2: 10.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088CCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.60204cb89529003d294483903a9a095a.svg";
export { ForwardRef as ReactComponent };